
import { TripResultDTO } from "../../apiclient/ApiDtos";
import { TripSearchFsmContext } from "../trip-search/TripSearchFsmContext";

export class TripSelectedFsmContext {
    constructor(
        public readonly tripSearchContext: TripSearchFsmContext,  
        public readonly selectedTrip: TripResultDTO) {
    }
}
